import Mustache from 'mustache';

import BaseExportProvider from './base.provider';

export default class HTMLBaseExportProvider extends BaseExportProvider {
  static async renderContent({ store, noteUuid, content }) {
    const parsedContent = Mustache.parse(content);
    const variables = parsedContent.filter(node => node[0] === 'name').map(node => node[1]);

    if (variables.length === 0) {
      return content;
    }

    let newContent = content;

    // Images
    let images = await store.dispatch('images/getAll', { noteUuid });
    images = Object.fromEntries(images.map(image => [image.uuid, image.data]));

    newContent = Mustache.render(content, {
      images,
    });

    return newContent;
  }
}
